import type { SxStyle } from '@aibees/shared/theme';

export const root: SxStyle = {
  // height: '100%',
};

export const items: SxStyle = {
  borderRightWidth: '1px',
  borderRightStyle: 'solid',
  borderRightColor: (p) => p.palette.grey[300],
  padding: (p) => p.spacing(1),
};

export const container: SxStyle = {
  width: '100%',
  height: '100%',
};

export const skeleton: SxStyle = {
  width: '100%',
  height: (p) => p.spacing(8.5),
};
